import { PermitRequest } from "@components/resolvers/permit.resolver";
import { BaseResponse, BaseResponseExternal } from "./dtos/base.dto";
import { BaseService } from "./base.service";
import { PermitResponse, PermitSettingResponse } from "./dtos/permit.dto";

interface PermitServiceInterface {
  queries: {
    GET_PERMIT_DATA: string;
    GET_PERMIT_SETTING: string;
  };
  request(payload: PermitRequest): Promise<BaseResponse<boolean>>;
  data(payload: { nis: string; limit: string }): Promise<PermitResponse>;
  permitCancel(payload: { id: string }): Promise<BaseResponse>;
  setting(): Promise<PermitSettingResponse>;
}

export const PermitService: PermitServiceInterface = {
  queries: {
    GET_PERMIT_DATA: "GET_PERMIT_DATA",
    GET_PERMIT_SETTING: "GET_PERMIT_SETTING",
  },

  request: async (payload: PermitRequest) => {
    try {
      const request = await BaseService.ci4Request().post(
        "/perizinan/request",
        payload,
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  data: async (payload: { nis: string; limit: string }) => {
    try {
      const request = await BaseService.ci4Request().get<PermitResponse>(
        "/perizinan/record",
        { params: payload },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  permitCancel: async (payload: { id: string }) => {
    try {
      const request = await BaseService.ci4Request().get<BaseResponseExternal>(
        "/perizinan/cancel",
        { params: payload },
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },

  setting: async () => {
    try {
      const request = await BaseService.ci4Request().get<PermitSettingResponse>(
        "/perizinan/data-setting",
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
};
